import { createPinia } from 'pinia'
import { createApp } from 'vue'
import '@fortawesome/fontawesome-free/css/all.min.css'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import languages from './lang'
import { restoreAllUserComponents } from "@/library/userModuleRegistry";


const app = createApp(App)
app.use(createPinia())

const i18n = createI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en',
    messages: languages
})

restoreAllUserComponents();
app.use(i18n)
app.mount('#app')

